export default __webpack_public_path__ + "static/media/gugen.3d5d71cc.svg";